const apiVersion = 'api/v1'
const apiMeasurements = process.env.VUE_APP_API_BRAKE

export const headersMeasurement = {
  headers: {
    Authorization: `${ localStorage.getItem('TOKEN_MEASUREMENT') }`
  }
}

export const auth = {
  totp: {
    create: ``,
    verify: ``,
    login: ``
  },
  u2f: {
    registration: {
      options: '',
      registration: ''
    },
    authorization: {
      options: `${ apiVersion }/accounts/authorization/fido2/begin/`,
      authorization: `${ apiVersion }/accounts/authorization/fido2/complete/`
    }
  },
  general: {
    login: `${ apiVersion }/accounts/login/`
  },
  phone: {
    login: ''
  }
}

export const directories = [
  { endpoint: `${ apiVersion }/directory/general/region/?country=1`, state: 'region' },
  { endpoint: `${ apiVersion }/directory/vehicle/vehicle_mark/`, state: 'vehicleMark' },
  { endpoint: `${ apiVersion }/directory/vehicle/vehicle_type/`, state: 'vehicleType' },
  // { endpoint: `${ apiVersion }/directory/laboratory/branch_office/`, state: 'laboratoryBranchOffice'},
  // { endpoint: `${ apiVersion }/directory/laboratory/measuring_laboratory/`, state: 'measuringLaboratory'},
  // { endpoint: `${ apiVersion }/directory/certification_agency/agency/`,
  // state: 'certificationAgency'},
  { endpoint: `${ apiVersion }/directory/vehicle/carcass_type/`, state: 'carcassType' },
  { endpoint: `${ apiVersion }/directory/vehicle/manufacturer_country/`, state: 'manufacturerCountry' },
  { endpoint: `${ apiVersion }/directory/engine/manufacturer_company/`, state: 'engineManufacturer' },
  { endpoint: `${ apiVersion }/directory/vehicle/vehicle_category/`, state: 'vehicleCategory' },
  { endpoint: `${ apiVersion }/directory/inspection/legal_act/`, state: 'legalActs' },
  // { endpoint:
  // `${ apiVersion }/accounts/certification_agency_for_laboratory_worker/`,
  // state: 'certificationAgency'},
  { endpoint: `${ apiVersion }/directory/engine/cooling_system/`, state: 'coolingSystem' },
  { endpoint: `${ apiVersion }/directory/engine/cylinder_arrangement/`, state: 'cylinderArrangement' },
  { endpoint: `${ apiVersion }/directory/engine/euro_rate/`, state: 'euroRate' },
  { endpoint: `${ apiVersion }/directory/engine/location/`, state: 'engineLocation' },
  { endpoint: `${ apiVersion }/directory/engine/pollution_reduction/`, state: 'pollutionReduction' },
  { endpoint: `${ apiVersion }/directory/engine/working_principle/`, state: 'workingPrinciple' },
  { endpoint: `${ apiVersion }/directory/vehicle/drive/`, state: 'vehicleDrive' },
  { endpoint: `${ apiVersion }/directory/steering/steering_boost_method/`, state: 'steeringBoostMethod' },
  { endpoint: `${ apiVersion }/directory/steering/wheel_location/`, state: 'steeringWheelLocation' },
  { endpoint: `${ apiVersion }/directory/transmission/type/`, state: 'transmissionType' },
  { endpoint: `${ apiVersion }/directory/vehicle/color/`, state: 'vehicleColor' },
  { endpoint: `${ apiVersion }/directory/vehicle/headlight_type/`, state: 'headlightType' },
  { endpoint: `${ apiVersion }/directory/vehicle/wheel_formula/`, state: 'wheelFormula' },
  { endpoint: `${ apiVersion }/directory/vehicle/identification_method/`, state: 'vehicleIdentificationMethod' },
  { endpoint: `${ apiVersion }/directory/vehicle/identification_place/`, state: 'vehicleIdentificationPlace' },
  { endpoint: `${ apiVersion }/directory/vehicle/fuel_type/`, state: 'fuelType' },
  { endpoint: `${ apiVersion }/directory/vehicle/window_type/`, state: 'windowType' },
  { endpoint: `${ apiVersion }/directory/vehicle/door_location/`, state: 'doorLocation' },
  { endpoint: `${ apiVersion }/directory/trailer/trailer_type_brake_connector/`, state: 'trailerTypeBrakeConnector' },
  { endpoint: `${ apiVersion }/directory/vehicle/seat_position/`, state: 'seatPosition' },
  { endpoint: `${ apiVersion }/directory/vehicle/belt_category/`, state: 'beltCategory' }
]

export const directory = {
  regions: `${ apiVersion }/directory/general/region/?country=1`,
  cityByParams: params => `${ apiVersion }/directory/general/city/${ params }`,
  city: id => `${ apiVersion }/directory/general/city/${ id ? `${ id }/` : '' }`,
  typeStreet: `${ apiVersion }/directory/general/type_street/`,
  vehicleCategory: `${ apiVersion }/directory/vehicle/vehicle_category/`,
  vehicleMarkByParams: params => `${ apiVersion }/directory/vehicle/vehicle_mark/${ params }`,
  vehicleModel: id => `${ apiVersion }/directory/vehicle/vehicle_model/${ id }/`,
  vehicleModelByParams: params => `${ apiVersion }/directory/vehicle/vehicle_model/${ params }`,
  vehicleModificationByModel: id => `${ apiVersion }/directory/vehicle/vehicle_modification/?vehicle_model=${ id }`,
  euroCodes: id => `${ apiVersion }/directory/engine/euro_code/?vehicle_id=${ id }`,
  legalActs: id => `${ apiVersion }/directory/inspection/legal_act/?euro_codes=${ id }`,
  legalActsNew: `${ apiVersion }/directory/inspection/legal_act/?vehicle_condition=New`,
  organizationType: `${ apiVersion }/directory/general/organization_type/`,
  euroCode: id => `${ apiVersion }/directory/engine/euro_code/${ id }/`,
  legalAct: id => `${ apiVersion }/directory/inspection/legal_act/${ id }/`,
  brakeControlType: `${ apiVersion }/directory/vehicle/brake_control_type/`,
  brakeType: `${ apiVersion }/directory/vehicle/brake_type/`,
  weather: idCity => `${ apiVersion }/directory/general/city/${ idCity }/weather/`,
  agency: id => `${ apiVersion }/directory/certification_agency/agency/${ id }/`,
  laboratory: id => `${ apiVersion }/directory/laboratory/measuring_laboratory/${ id }/`,
  laboratoryAgencyLists: params => `${ apiVersion }/directory/laboratory/branch_office/${ params }`,
  certificationAgencyLists: params => `${ apiVersion }/directory/certification_agency/agency/${ params }`,
  listMeasuringLaboratories: params => `${ apiVersion }/directory/laboratory/measuring_laboratory/${ params ?
    params :
    '' }`
}

export const profile = {
  me: `${ apiVersion }/accounts/me/`,
  counter: `${ apiVersion }/accounts/counter/`,
  meGuest: `${ apiVersion }/registration/guest/me/`,
  sessions: `${ apiVersion }/token/token/`,
  signature: `${ apiVersion }/signature/key_signature/`,
  deleteSignature: id => `${ apiVersion }/signature/key_signature/${ id }/`,
  signIn: `${ apiVersion }/accounts/login/`,
  changePassword: `${ apiVersion }/accounts/password/`,
  resetPassword: id => `${ apiVersion }/registration/measuring_laboratory/user/${id}/reset_password/`,
  qr: `${ apiVersion }/integration/stands/invitation/get_invitation_code/`,
  getTokenByQR: `${ apiMeasurements }/mobile/invitation/`,
  profileDocuments: `${ apiVersion }/accounts/me/upload_file/`,
  updateDocumentsProfile: `${ apiVersion }/accounts/me/update_file/`,
  updateDocumentsGuestProfile: `${ apiVersion }/registration/guest/me/update_file/`,
  removeDocumentProfile: file_id => `${ apiVersion }/accounts/me/remove_file/${ file_id }/`,
  removeDocumentGuestProfile: file_id => `${ apiVersion }/registration/guest/me/remove_file/${ file_id }/`,


  sendRecoveryPasswordTokenToEmail: `${ apiVersion }/accounts/send_password_recovery_email/`,
  recoveryPasswordByToken: `${ apiVersion }/accounts/change_password_by_token/`,
}

export const statement = {
  statement: `${ apiVersion }/statement/statement_for_certification/`,
  clientStatement: `${ apiVersion }/client_statements/client_statement_certification/`,
  counterClientStatement: `${ apiVersion }/client_statements/client_statements_counter/`,
  change: statement => `${ apiVersion }/statement/statement_for_certification/${ statement }/`,
  media: statement => `${ apiVersion }/statement/statement_for_certification/${ statement }/upload_file/`,
  pdfTechnicalControl: statement =>
    `${ apiVersion }/document_generation/generate_statement_for_tech_inspection/${ statement }/`,
  pdfStatement: statement => `${ apiVersion }/document_generation/generate_statement_for_certification/${ statement }/`,
  decisionPDF: decision => `${ apiVersion }/document_generation/generate_statement_decision/${ decision }/`,
  clientSignature: statement =>
    `${ apiVersion }/statement/statement_for_certification/${ statement }/upload_client_watermark/`,
  decision: statement => `${ apiVersion }/statement/statement_for_certification/${ statement }/decision/`,
  decisionAction: statement =>
    `${ apiVersion }/statement/statement_for_certification/${ statement }/decision/`,
  decisionSign: `${ apiVersion }/signature/statement_decision/`,
  statementSign: `${ apiVersion }/signature/statement_for_certification/`,
  agreement: statement =>
    `${ apiVersion }/document_generation/certification/generate_consent_collect_personal_data/${ statement }/`,
  vinDecode: vinCode => `${ apiVersion }/vehicle_configurator/vin_decode/${ vinCode }/`,
  getEuroCodes: params => `${ apiVersion }/directory/engine/euro_code/?${ params }`,
  identificationAct: id => `${ apiVersion }/statement/statement_for_certification/${ id }/identification_act/`,
  updateIdentificationAct: params =>
    `${ apiVersion }/statement/statement_for_certification/${ params.statementId }/identification_act/`,
  identificationActMedia: params =>
    `${ apiVersion }/statement/statement_for_certification/${ params.statementId }/identification_act/upload_file/`,
  clientSignatureIdentificationAct: params =>
    `${ apiVersion }/statement/statement_for_certification/${ params.statementId }/identification_act/upload_client_watermark/`,
  pdfIdentificationAct: statement =>
    `${ apiVersion }/document_generation/generate_act_identification/${ statement }/`,
  identificationActSign: `${ apiVersion }/signature/identification_act/`,
  vehicleCategory: `${ apiVersion }/directory/vehicle/vehicle_category/`,
  statementChangeResponsiblePerson: id => `${ apiVersion }/statement/statement_for_certification/${ id }/change_assigned_to/`
}

export const client = {
  client: `${ apiVersion }/client/client/`,
  clientById: id => `${ apiVersion }/client/client/${ id }/`,
  passport: client => `${ apiVersion }/client/client/${ client }/passport/`
}

export const branches = {
  laboratory: id => `${ apiVersion }/directory/laboratory/measuring_laboratory/${ id }/`,
  branches: `${ apiVersion }/directory/laboratory/branch_office/`,

  branch: id => `${ apiVersion }/directory/laboratory/branch_office/${ id }/`,

  branchMediaUpload: id => `${ apiVersion }/directory/laboratory/branch_office/${ id }/upload_file/`,
  branchMediaUpdate: id => `${ apiVersion }/directory/laboratory/branch_office/${ id }/update_file/`,
  branchMediaRemove: params => `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/remove_file/${ params.fileId }/`,

  statementBranch: id => `${ apiVersion }/directory/laboratory/statement_branch_office/${ id ? `${ id }/` : '' }`,
  updateStatementBranch: params => `${ apiVersion }/directory/laboratory/statement_branch_office/${ params.branchId }/`,
  updateLaboratoryBranch: params => `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/`,
  updateLaboratoryBranchStatement: params => `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/registrate_new_laboratory_branch_statement/`,

  statementBranchMediaUpload: id => `${ apiVersion }/directory/laboratory/statement_branch_office/${ id }/upload_file/`,
  statementBranchMediaUpdate: id => `${ apiVersion }/directory/laboratory/statement_branch_office/${ id }/update_file/`,
  statementBranchMediaRemove: params => `${ apiVersion }/directory/laboratory/statement_branch_office/${ params.branchId }/remove_file/${ params.fileId }/`,

  reprocessingStatementBranch: params => `${ apiVersion }/moderation/measuring_laboratory/${ params.id }/statement_laboratory_branch/${ params.branchId }/question/`,
  reprocessingStatementBranchFile: params => `${ apiVersion }/moderation/measuring_laboratory/${ params.id }/statement_laboratory_branch/${ params.branchId }/question/file/`,

  equipmentType: `${ apiVersion }/directory/laboratory/equipment_type/`,

  branchEquipment: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/work_line/${ params.workLineId }/equipment/`,
  updateBranchEquipment: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/work_line/${ params.workLineId }/equipment/${ params.id }/`,
  updateBranchEquipmentMedia: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/work_line/${ params.workLineId }/equipment/${ params.id }/upload_serial_number_photo/`,
  workLine: id => `${ apiVersion }/directory/laboratory/branch_office/${ id }/work_line/`,
  deleteWorkLine: params => `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/work_line/${params.workLineId}/`,

  statementBranchEquipment: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/statement/work_line/${ params.workLineId }/equipment/`,
  updateStatementBranchEquipment: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/statement/work_line/${ params.workLineId }/equipment/${ params.id }/`,
  updateStatementBranchEquipmentMedia: params =>
    `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/statement/work_line/${ params.workLineId }/equipment/${ params.id }/upload_serial_number_photo/`,

  statementWorkLine: id => `${ apiVersion }/directory/laboratory/branch_office/${ id }/statement/work_line/`,
  updateStatementWorkLine: params => `${ apiVersion }/directory/laboratory/branch_office/${ params.branchId }/statement/work_line/${ params.workLineId }/`,

  checkEquipment: `${ apiVersion }/document_generation/check-equipment`,
  generateLetter: `${ apiVersion }/document_generation/generate_letter`,
  generateStatement: `${ apiVersion }/document_generation/generate_statement`,
  generateSurvey: `${ apiVersion }/document_generation/generate_survey`,
  generatePassport: `${ apiVersion }/document_generation/generate_passport`,
  generateAccreditation: `${ apiVersion }/document_generation/generate_accreditation`,
  generateQuestionnaire: `${ apiVersion }/document_generation/generate_questionnaire`,
  generateEvaluation: `${ apiVersion }/document_generation/generate_evaluation`,
  generateDocumentsList: `${ apiVersion }/document_generation/generate_document-list`
}

export const inspection = {
  inspection: `${ apiVersion }/inspection/vehicle_inspection/`,
  action: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/`,
  questions: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/question/`,
  legalActQuestions: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/question/legal_act_questions/`,

  inconsistency: id => `${apiVersion}/inspection/vehicle_inspection/${id}/inconsistency/`,
  inconsistencyAction: (id, itemId) => `${apiVersion}/inspection/vehicle_inspection/${id}/inconsistency/${itemId}/`,
  decisionLegalActs: id => `${ apiVersion }/certification/decision_issuing_certificate/${ id }/decision/legal_act/`,
  setDecisionLegalAct: (decisionId, idLegalAct) => `${ apiVersion }/certification/decision_issuing_certificate/${ decisionId }/decision/legal_act/${ idLegalAct }/`,

  questionsActions: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/question/update_array_of_questions/`,
  proof: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/proof/`,
  dependency: id => `${ apiVersion }/inspection/inspection_dependency_for_statement/${ id }/`,
  light: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/light/`,
  setLightTransmission: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/light_transmission/bulk_create/`,
  getLightTransmission: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/light_transmission/`,
  brake: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/brake/`,
  brakeMeasurementStands: params => `${ apiVersion }/${ params.typeInspection }/${ params.id }/stands/brake/`,
  setGas: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/gas/bulk_create/`,
  updateGas: params => `${ apiVersion }/${ params.typeInspection }/${ params.id }/gas/${ params.gasId }/`,
  getGas: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/gas/`,
  setSmoke: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/smoke/bulk_create/`,
  updateSmoke: params => `${ apiVersion }/${ params.typeInspection }/${ params.id }/smoke/${ params.smokeId }/`,
  getSmoke: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/smoke/`,
  noise: id => `${ apiVersion }/inspection/vehicle_inspection/${ id }/noise/`,
  findVehicle: params => `${ apiVersion }/vehicle_configurator/vehicle/?${ params }`,
  getVehicleHeadlight: id => `${ apiVersion }/inspection/vehicle_headlight/${ id }`,
  inspectionProtocolPdf: id => `${ apiVersion }/document_generation/generate_vehicle_inspection/${ id }/`,
  signCompliance: `${ apiVersion }/signature/vehicle_inspection/`,
  pdfDecisionIssuing: id => `${ apiVersion }/document_generation/generate_decision_issuing_certificate/${ id }/`,
  pdfCertificate: id => `${ apiVersion }/document_generation/generate_vehicle_cetificate/${ id }/`,
  pdfCertificateAppendix: id => `${ apiVersion }/document_generation/generate_appendix_to_certificate/${ id }/`,
  decisionIssue: `${ apiVersion }/certification/decision_issuing_certificate/`,
  decisionIssueAction: id => `${ apiVersion }/certification/decision_issuing_certificate/${ id }/`,
  certificate: `${ apiVersion }/certification/vehicle_certificate/`,
  decisionIssueSign: `${ apiVersion }/signature/decision_issuing_certificate/`,
  certificateSign: `${ apiVersion }/signature/vehicle_certificate/`,
  certificateAppendixSign: `${ apiVersion }/signature/appendix_to_certificate/`,
  sendCertificateToUAS: id => `${ apiVersion }/certification/vehicle_certificate/${id}/send_vehicle_certificate_to_uas/`,
  manualCertificationNumber: id => `${ apiVersion }/certification/certification/decision_issuing_certificate/manual_certification_number/${ id }/`,
  addInspectionProtocolNumber: id => `${ apiVersion }/inspection/vehicle_assigned_number/${ id }/`,

  // integration
  measurementResult: id => `${apiVersion}/integration/stands/inspection/${id}/get_measurements/`,
  getCarcassTypesByCategory: id => `${apiVersion}/directory/vehicle/carcass_type/?category=${id}`,
  inspectionChangeResponsiblePerson: id => `${ apiVersion }/inspection/vehicle_inspection/${id}/change_assigned_to/`,

  equipment: params => `${ apiVersion }/inspection/vehicle_inspection/stands/${params.number}/${params.type}/${params.id ? `${params.id}/` : ''}`,
  zigBeeEquipment: params => `${ apiVersion }/${params.typeInspection}/${params.number}/zigbee/${params.type}/${params.id ? `${params.id}/` : ''}`,
  startMeasurementForZigBeeEquipment: params => `${ apiVersion }/${params.typeInspection}/${params.number}/zigbee/${params.type}/${params.id}/next_measurement/`,

  startMeasurementLightZigBee: params => `${ apiVersion }/inspection/vehicle_inspection/${params.number}/zigbee/${params.type}/next_measurement/${params.mode}/`,
  startMeasurementLightZigBeeOTK: params => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${params.number}/zigbee/${params.type}/next_measurement/${params.mode}/`,

  equipmentList: params => `${ apiVersion }/inspection/vehicle_inspection/stands/${params.number}/${params.type}/get_equipments/`,
  nextMeasurement: params => `${ apiVersion }/inspection/vehicle_inspection/stands/${params.declarationID}/noise/${params.measurementNumber}/next_measurement/`,

  measurementInfo: params => `${ apiVersion }/inspection/vehicle_inspection/${params.inspection}/${params.interaction ? `${params.interaction}/` : ''}${params.type}/${params.id ? `${params.id}/` : ''}`,

  measurementInfoOTK: params => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${params.inspection}/${params.interaction ? `${params.interaction}/` : ''}${params.type}/${params.id ? `${params.id}/` : ''}`,

  terminateInspection: id => `${ apiVersion }/inspection/equipments/${id}/terminate_inspection/`,

  // terminateInspectionOTK: params => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/
  // ${params.inspection}/zigbee/${params.type}/terminate_inspection/`,
}

export const measurement = {
  stands: `${ apiMeasurements }/stand/`,
  standsOffline: `${ apiMeasurements }/stand/offline`,
  stand: id => `${ apiMeasurements }/stand/find?stand_id=${ id }`,
  standCharacteristics: id => `${ apiMeasurements }/action/consts?stand_serial=${ id }`,
  standCharacteristicsSave: `${ apiMeasurements }/action/consts`,
  standInfo: `${ apiMeasurements }/admin/stand-info`,
  standCheckConnect: id => `${ apiMeasurements }/stand/offline/check/?stand_serial=${ id }`,
  standReboot: id => `${ apiMeasurements }/action/${ id }/abort`,
  calibrationWeight: `${ apiMeasurements }/action/calibrate/weight`,
  calibrationBrake: `${ apiMeasurements }/action/calibrate/brake`,
  measurementDeparture: id => `${ apiMeasurements }/action/${ id }/drive_out`,
  createMeasurementDeclaration: `${ apiMeasurements }/stand/declaration`,
  checkStandStatusInfo: id => `${ apiMeasurements }/action/${ id }/check`,
  checkStandStatus: id => `${ apiMeasurements }/action/${ id }/status`,
  startMeasurement: (stand, declaration, measurement, type, params) =>
    `${ apiMeasurements }/action/${ stand }/${ measurement }/${ declaration }/${ type }${ params ? `?${ params }` : '' }`,
  arduinoLogs: id => `${ apiMeasurements }/admin/arduino/log/${ id }`,
  standConnect: (stand, type) => `${ apiMeasurements }/action/${ stand }/${ type }`,
  standAnalyzerType: type => `${ apiMeasurements }/stand/analyzer/${ type }`,
  occupyStand: id => `${ apiMeasurements }/action/${ id }/occupy`,
  turnOffTheStand: id => `${ apiMeasurements }/action/${ id }/release`,
  sensorTest: data => `${ apiMeasurements }/action/${ data.id }/sensor_test/${ data.type }/`,
  inspectionEquipment: id => `${ apiVersion }/inspection/equipments/${ id ? `${ id }/` : ''}`,
  getBrakeEquipmentForCalibration: `${ apiVersion }/directory/laboratory/branch_office/zigbee/brake_stand/`
}

export const technicalControl = {
  statement: `${ apiVersion }/statement_mti/statement_for_tech_inspection/`,
  clientStatement: `${ apiVersion }/client_statements/client_statement_mti/`,
  statementChange: id => `${ apiVersion }/statement_mti/statement_for_tech_inspection/${ id }/`,
  media: statement => `${ apiVersion }/statement_mti/statement_for_tech_inspection/${ statement }/upload_file/`,
  clientSignature: statement =>
    `${ apiVersion }/statement_mti/statement_for_tech_inspection/${ statement }/upload_client_watermark/`,
  agreement: statement =>
    `${ apiVersion }/document_generation/technical_inspection/generate_consent_collect_personal_data/${ statement }/`,
  statementSign: `${ apiVersion }/signature/statement_for_tech_inspection/`,
  headlightDependency: params => `${ apiVersion }/directory/inspection_mti/headlight_dependency/?${ params }`,
  inspection: `${ apiVersion }/inspection_mti/vehicle_inspection_mti/`,
  vehicleInspection: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/`,
  inspectionQuestions: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/question/`,
  exceptionCodes: `${ apiVersion }/directory/inspection_mti/exception_code/`,
  updateArrayOfQuestions: id =>
    `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/question/update_array_of_questions/`,
  vehicleSpecialPurpose: `${ apiVersion }/directory/vehicle/special_purpose`,
  measurementResult: id => `${ apiVersion }/integration/stands/inspection_mti/${ id }/get_measurements/`,
  setLightTransmissionMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/light_transmission/bulk_create/`,
  lightTransmissionMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/light_transmission/`,
  brakeMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/brake/`,
  lightMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/light/`,
  setGasMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/gas/bulk_create/`,
  getGasMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/gas/`,
  setSmokeMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/smoke/bulk_create/`,
  getSmokeMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/smoke/`,
  noiseMeasurement: id => `${ apiVersion }/inspection_mti/vehicle_inspection_mti/${ id }/noise/`,
  signatureInspectionMti: `${ apiVersion }/signature/inspection_mti/`,
  signatureNonComplianceAct: `${ apiVersion }/signature/non_compliance_act/`,
  signatureProtocolMti: `${ apiVersion }/signature/protocol_mti/`,
  getDocumentMtiInspection: id => `${ apiVersion }/document_generation/generate_mti_inspection/${ id }/`,
  getProtocolMtiInspection: id => `${ apiVersion }/document_generation/generate_mti_protocol/${ id }/`,
  getNonComplianceAct: id => `${ apiVersion }/document_generation/generate_non_compliance_act/${ id }/`
}

export const userVL = {
  user: `${ apiVersion }/registration/measuring_laboratory/user/`,
  userChange: id => `${ apiVersion }/registration/measuring_laboratory/user/${ id }/`,
  userMedia: id => `${ apiVersion }/registration/measuring_laboratory/user/${ id }/upload_file/`,
  updateUserMedia: id => `${ apiVersion }/registration/measuring_laboratory/user/${ id }/update_file/`,
  deleteUserMedia: params => `${ apiVersion }/registration/measuring_laboratory/user/
    ${ params.id }/remove_file/${ params.fileId }/`,
  refreshPassword: id => `${ apiVersion }/registration/measuring_laboratory/user/${ id }/reset_password/`
}

export const accountOC = {
  registrationCertificationAgency: `${ apiVersion }/registration/statement/certification_agency/`,
  uasInfoApiKey: `${ apiVersion }/directory/certification_agency/uas_api_key/`,
  updateCertificationAgencyInRegistration: id => `${ apiVersion }/registration/statement/certification_agency/${ id }/`,
  certificationAgencyUploadFile: id => `${ apiVersion }/registration/statement/certification_agency/${ id }/upload_file/`,
  certificationAgencyUpdateFileInRegistration: id =>
    `${ apiVersion }/registration/statement/certification_agency/${ id }/update_file/`,
  certificationAgencyRemoveFileInRegistration: (agency_id, file_id) =>
    `${ apiVersion }/registration/statement/certification_agency/${ agency_id }/remove_file/${ file_id }/`,
  getCertificationAgency: id => `${ apiVersion }/directory/certification_agency/agency/${ id }/`,
  updateCertificationAgency: id => `${ apiVersion }/directory/certification_agency/agency/${ id }/`,
  certificationAgencyRemoveFile: (agency_id, file_id) =>
    `${ apiVersion }/directory/certification_agency/agency/${ agency_id }/remove_file/${ file_id }/`,
  certificationAgencyUpdateFiles: agency_id =>
    `${ apiVersion }/directory/certification_agency/agency/${ agency_id }/update_file/`,
  addEmployees: agency_id =>
    `${ apiVersion }/registration/statement/certification_agency/${ agency_id }/accreditation_employee/bulk_create/`,
  accreditationEmployee: id => `${ apiVersion }/registration/statement/certification_agency/${ id }/accreditation_employee/`,
  updateAndRemoveAccreditationEmployee: (id, employee) =>
    `${ apiVersion }/registration/statement/certification_agency/${ id }/accreditation_employee/${ employee }/`,
  accreditationEmployeeUploadFiles: (id, idEmployee) =>
    `${ apiVersion }/registration/statement/certification_agency/${ id }/accreditation_employee/${ idEmployee }/upload_file/`,
  accreditationEmployeeUpdateFiles: (id, idEmployee) =>
    `${ apiVersion }/registration/statement/certification_agency/${ id }/accreditation_employee/${ idEmployee }/update_file/`,
  accreditationEmployeeDeleteFiles: (agency_id, employee_id, file_id) =>
    `${ apiVersion }/registration/statement/certification_agency/${ agency_id }/accreditation_employee/${ employee_id }/remove_file/${ file_id }/`,

  branchCertificationAgency: id => `${ apiVersion }/directory/certification_agency/branch/${ id }/`,
  getAndPostBranchesCertificationAgency: `${ apiVersion }/directory/certification_agency/branch/`,
  statementBranchCertificationAgency: id => `${ apiVersion }/directory/certification_agency/statement_branch/${ id }/`,
  getAndPostStatementBranchesCertificationAgency: `${ apiVersion }/directory/certification_agency/statement_branch/`,

  // Співробітники
  employees: `${ apiVersion }/registration/certification_agency/user/`,
  moderationEmployees: `${ apiVersion }/directory/certification_agency/statement_employee/`,
  employee: id => `${ apiVersion }/registration/certification_agency/user/${ id }/`,
  employeeUpdateFiles: id => `${ apiVersion }/registration/certification_agency/user/${ id }/update_file/`,
  employeeCabinet: id => `${ apiVersion }/directory/certification_agency/statement_employee/${ id }/`,
  employeeCabinetUpdateFiles: id => `${ apiVersion }/directory/certification_agency/statement_employee/${ id }/update_file/`,
  addEmployee: `${ apiVersion }/registration/certification_agency/statement_user/bulk_create/`,
  outOfSystemEmployees: `${ apiVersion }/registration/certification_agency/statement_user/`,
  outOfSystemEmployee: id => `${ apiVersion }/registration/certification_agency/statement_user/${ id }/`,
  systemicAndOutOfSystemEmployeeUploadFiles: id =>
    `${ apiVersion }/registration/certification_agency/statement_user/${ id }/upload_file/`,
  outOfSystemEmployeeUpdateFiles: id => `${ apiVersion }/registration/certification_agency/statement_user/${ id }/update_file/`,

  // Випробувальна лабораторія
  addLaboratory: `${ apiVersion }/registration/statement/contract_of_cooperation/`,
  laboratoryUploadFile: id =>
    `${ apiVersion }/registration/statement/contract_of_cooperation/${ id }/upload_file/`,
  getLaboratories: `${ apiVersion }/directory/contract/`,
  getAndUpdateLaboratory: id => `${ apiVersion }/directory/contract/${ id }/`,
  removeFileLaboratory: (laboratory_id, file_id) =>
    `${ apiVersion }/directory/contract/${ laboratory_id }/remove_file/${ file_id }/`,
  updateFileLaboratory: id => `${ apiVersion }/directory/contract/${ id }/update_file/`,

  // Статистика заявок
  getStatistic: params => `${ apiVersion }/statement/statement_for_certification/statistic?${ params ? params : '' }`,
  getStatisticUasRegister: params => `${ apiVersion }/certification/vehicle_certificate/statistic?${ params ?
    params :
    '' }`,
  filterStatistic: params => `${ apiVersion }/statement/statement_for_certification/statistic?${ params }`
}

export const accountVL = {
  measuringLaboratory: `${ apiVersion }/registration/statement/measuring_laboratory/`,
  updateMeasuringLaboratory: id => `${ apiVersion }/registration/statement/measuring_laboratory/${ id }/`,
  measuringLaboratoryList: `${ apiVersion }/registration/statement/measuring_laboratory/`,
  measuringLaboratoryMedia: id => `${ apiVersion }/registration/statement/measuring_laboratory/${ id }/upload_file/`,
  measuringLaboratoryUpdateMedia: id => `${ apiVersion }/registration/statement/measuring_laboratory/${ id }/update_file/`,

  deleteMeasuringLaboratoryMedia: params => `${ apiVersion }/registration/statement/measuring_laboratory/${ params.laboratoryId }/remove_file/${ params.id }/`,

  contractWithOC: id => `${ apiVersion }/registration/statement/measuring_laboratory/${ id }/contract/`,
  updateContractWithOC: params =>
    `${ apiVersion }/registration/statement/measuring_laboratory/${ params.laboratoryId }/contract/${ params.id }/`,
  contractWithOCMedia: props =>
    `${ apiVersion }/registration/statement/measuring_laboratory/${ props.laboratoryId }/contract/${ props.id }/upload_file/`,
  contractWithOCUpdateMedia: props =>
    `${ apiVersion }/registration/statement/measuring_laboratory/${ props.laboratoryId }/contract/${ props.id }/update_file/`,

  deleteContractMedia: props =>
    `${ apiVersion }/registration/statement/measuring_laboratory/${ props.laboratoryId }/contract/
    ${ props.contractId }/remove_file/${ props.id }/`,

  branchVL: (id, branchId) => `${ apiVersion }/registration/statement/measuring_laboratory/${ id }/laboratory_branch/${ branchId ?
    `${ branchId }/` :
    '' }`,
  branchVLItem: params =>
    `${ apiVersion }/registration/statement/measuring_laboratory/${ params.laboratoryId }/laboratory_branch/${ params.branchId }/`,
  branchVLMedia: params =>
    `${ apiVersion }/registration/statement/measuring_laboratory/
    ${ params.laboratoryId }/laboratory_branch/${ params.branchId }/upload_file/`,
  branchVLUpdateMedia: params =>
    `${ apiVersion }/registration/statement/measuring_laboratory/
    ${ params.laboratoryId }/laboratory_branch/${ params.branchId }/update_file/`,
  branchVLDeleteMedia: params =>
    `${ apiVersion }/registration/statement/measuring_laboratory/
    ${ params.laboratoryId }/laboratory_branch/${ params.branchId }/remove_file/${ params.fileId }/`
}

export const contract = {
  // Заяви на співробітництво
  contracts: `${ apiVersion }/registration/statement/contract_of_cooperation/`,
  contractsMedia: id => `${ apiVersion }/registration/statement/contract_of_cooperation/${ id }/upload_file/`,
  contract: id => `${ apiVersion }/registration/statement/contract_of_cooperation/${ id }/`,

  // Угоди про співробітництво
  cooperationAgreements: `${ apiVersion }/directory/contract/`,
  cooperationAgreement: id => `${ apiVersion }/directory/contract/${ id }`
}

export const search = {
  search: `${ apiVersion }/search/certification_document/`
}

export const techSupport = {
  inquiry: `${ apiVersion }/core/feedback/`
}

export const siteNotification = {
  notification: `${ apiVersion }/core/site-notification/`
}

export const moderationQuestionOC = {
  mainQuestion: id => `${ apiVersion }/moderation/statement_certification_agency/${ id }/question/`,
  mainQuestionFile: id => `${ apiVersion }/moderation/statement_certification_agency/${ id }/question/file/`,

  directorFile: id => `${ apiVersion }/moderation/statement_certification_agency/${ id }/question/director_file/`,

  branchList: id => `${ apiVersion }/moderation/statement_certification_agency/${ id }/statement_certification_branch/`,
  branchItem: params => `${ apiVersion }/moderation/statement_certification_agency/${ params.id }/statement_certification_branch/${ params.branchId }/question/`,
  branchItemCabinet: params => `${ apiVersion }/moderation/certification_agency/${ params.id }/statement_certification_branch/${ params.branchId }/question/`,

  employeeList: id => `${ apiVersion }/moderation/statement_certification_agency/${ id }/statement_certification_employee/`,
  employeeItem: params => `${ apiVersion }/moderation/statement_certification_agency/${ params.id }/statement_certification_employee/${ params.employeeId }/question/`,
  employeeFile: params => `${ apiVersion }/moderation/statement_certification_agency/${ params.id }/statement_certification_employee/${ params.employeeId }/question/file/`,
  employeeListCabinet: id => `${ apiVersion }/moderation/certification_agency/${ id }/statement_certification_employee/`,
  employeeItemCabinet: params => `${ apiVersion }/moderation/certification_agency/${ params.id }/statement_certification_employee/${ params.employeeId }/question/`,
  employeeFileCabinet: params => `${ apiVersion }/moderation/certification_agency/${ params.id }/statement_certification_employee/${ params.employeeId }/question/file/`,

}

export const moderationQuestionVL = {
  mainQuestion: id => `${ apiVersion }/moderation/statement_measuring_laboratory/${ id }/question/`,
  mainQuestionFile: id => `${ apiVersion }/moderation/statement_measuring_laboratory/${ id }/question/file/`,

  directorFile: id => `${ apiVersion }/moderation/statement_measuring_laboratory/${ id }/question/director_file/`,

  branchList: id => `${ apiVersion }/moderation/statement_measuring_laboratory/${ id }/statement_laboratory_branch/`,
  branchItem: params => `${ apiVersion }/moderation/statement_measuring_laboratory/${ params.id }/statement_laboratory_branch/${ params.branchId }/question/`,
  branchFile: params => `${ apiVersion }/moderation/statement_measuring_laboratory/${ params.id }/statement_laboratory_branch/${ params.branchId }/question/file/`
}

export const statementManual = {
  statementManual: id => `${apiVersion}/manual_statement/statement_for_certification/${id ? `${id}/` : ''}`,
  uploadMedia: id => `${apiVersion}/manual_statement/statement_for_certification/${id}/upload_file/`,
  statementManualDocument: id => `${apiVersion}/document_generation/manual_statement/${id}/`,
  clientSignature: id => `${apiVersion}/manual_statement/statement_for_certification/${id}/upload_client_watermark/`,
  statementSign: `${apiVersion}/signature/manual_statement/`,

  identificationAct: id => `${apiVersion}/manual_statement/statement_for_certification/${id}/identification_act/`,
  manualIdentificationActDocument: id => `${apiVersion}/document_generation/manual_act_identification/${id}/`,
  uploadManualIdentificationActMedia: params =>
    `${apiVersion}/manual_statement/statement_for_certification/${params.statementId}/identification_act/upload_file/`,
  clientSignatureIdentificationAct: params =>
    `${apiVersion}/manual_statement/statement_for_certification/${params.statementId}/identification_act/upload_client_watermark/`,
  identificationActSign: `${apiVersion}/signature/manual_act_identification/`
}

export const inspectionManual = {
  dependency: id => `${apiVersion}/manual_inspection/inspection_dependency_for_statement/${id}/`,
  inspectionManual: id => `${apiVersion}/manual_inspection/manual_inspections/${id ? `${id}/` : ''}`,



  noiseInspection: id => `${ apiVersion }/manual_inspection/manual_inspections/${ id }/noise/`,
  emissionInspection: id => `${ apiVersion }/manual_inspection/manual_inspections/${ id }/emission/`,
  vehicleConsumption: id => `${ apiVersion }/manual_inspection/manual_inspections/${ id }/consumption_and_co2/`
}